import {
  ProspectApiClient,
  PROSPECT_CONTACT_PATH,
  type ContactSaveRequest,
  type ContactSaveResponse,
} from '@highereducation/prospect';
import { getApiConfig } from './utils';

export { PROSPECT_CONTACT_PATH };

export type ProspectContactApiResponse = ContactSaveResponse;

const clientCache = new Map<string, ProspectApiClient>();

function getClient(): ProspectApiClient {
  const baseUrl = getApiConfig().prospectServiceApiUrl ?? '';
  let client = clientCache.get(baseUrl);
  if (!client) {
    clientCache.clear();
    client = new ProspectApiClient({
      baseUrl,
      defaultHeaders: {
        'Content-Type': 'application/json',
      },
    });
    clientCache.set(baseUrl, client);
  }
  return client;
}

/** Prospect Service contact save. */
export async function postProspectContact(
  body: ContactSaveRequest,
): Promise<ProspectContactApiResponse> {
  return getClient().postContact(body);
}
